export const TARGET_TYPES = [
  "Platform",
  "Region",
  "Itinerary",
  "Stop",
  "Listing",
].map((t) => ({ id: t, name: t }));
